<template>
  <div class="feat-card">
    <div class="feat-icon feat-icon--manual">
      <v-icon dark>beenhere</v-icon>
    </div>

    <div class="feat-body">
      <div class="feat-title">Antecipação Manual</div>
      <div class="feat-desc">
        Informe quanto deseja antecipar e envie a solicitação. Antecipe seus
        recebíveis de forma segura, quando quiser.
      </div>
      <div class="feat-chips">
        <span class="feat-chip">
          <v-icon small class="feat-chip__icon">percent</v-icon>
          Taxa: {{ tax && tax.manual_tax ? tax.manual_tax : "N/A" }}% a.m
        </span>
      </div>
    </div>

    <div class="feat-action">
      <manual-by-value-antecipation />
      <select-antecipation />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ManualAntecipation",
  mounted() {
    this.$store.dispatch("user/getAnticipationTax");
    this.$store.dispatch("user/getBalance");
  },
  computed: {
    ...mapGetters({
      tax: "user/anticipationTax",
    }),
  },
  components: {
    SelectAntecipation: () =>
      import("@/components/antecipation/SelectAntecipation.vue"),
    ManualByValueAntecipation: () =>
      import("@/components/antecipation/ManualByValueAntecipation.vue"),
  },
};
</script>

<style scoped>
.feat-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: #fafbfc;
  border: 1px solid #eef1f5;
  border-radius: 18px;
  padding: 18px 20px;
  transition: box-shadow 0.18s ease;
}
.feat-card:hover {
  box-shadow: 0 8px 22px rgba(17, 24, 39, 0.07);
}

.feat-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.feat-icon--manual {
  background: linear-gradient(135deg, #2ec87a, #15a35a);
  box-shadow: 0 6px 14px rgba(21, 163, 90, 0.32);
}

.feat-body {
  flex: 1;
  min-width: 0;
}

.feat-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2933;
}

.feat-desc {
  font-size: 13.5px;
  color: #4b5563;
  margin: 4px 0 10px;
  line-height: 1.45;
}

.feat-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.feat-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #eef2f7;
  color: #37475a;
  font-size: 12.5px;
  font-weight: 600;
  border-radius: 999px;
  padding: 4px 12px;
}
.feat-chip__icon {
  font-size: 15px !important;
  color: #7a8699 !important;
}

.feat-action {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

@media screen and (max-width: 600px) {
  .feat-card {
    flex-wrap: wrap;
  }
  .feat-action {
    width: 100%;
    justify-content: flex-end;
  }
}
</style>
